import React from 'react';
import { Panel } from 'react-bootstrap';

export default function AggregateView() {
  return (
    <Panel className="dashed-border m-0 text-center" name="aggregate-state">
      <Panel.Body>
        <h4 className="text-muted mb-4">
          Imports are unavailable while viewing All Databases
        </h4>
        <a
          className="btn btn-blue js-bootbox-link js-databases-modal-link"
          data-class="databases-modal js-databases-modal"
          data-inline="true"
          data-title="Switch Database"
          href="/database_settings"
        >
          Switch Database
        </a>        
      </Panel.Body>
    </Panel>
  );
}
